import { appConfig, headerConfig, refineHeader } from "../../config";

export const payoutService = {
  addPayoutTerms,
  getPayoutList,
  deletePayout,
  getPayoutTerms,
  updatePayoutTerms,
  getPayoutDropdownList
};

function addPayoutTerms(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}payment-term/add`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
  });
}

function updatePayoutTerms(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}payment-term/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
  });
}
function getPayoutDropdownList(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}payment-term/dropdown`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getPayoutList(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}payment-term/list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function deletePayout(termid) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}payment-term/delete/${termid}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getPayoutTerms(id){
    refineHeader();
    const requestOptions = {
        method: 'GET',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}payment-term/detail/${id}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}


// WEBPACK FOOTER //
// ./src/app/services/API/payoutService.js